<template>
  <div class="answer-detail">
    <div class="ans-count">共提交 {{ answerCount }} 人</div>
    <!-- 单选 -->
    <div v-for="(title, index) in titles" :key="index" class="title-item">
      <div class="title-head">
        <span class="index">{{ title.sort }}.</span>
        <span class="type">({{ typeLabel[title.type] }})</span>
        <span class="name">{{ title.name }}</span>
      </div>
      <div v-if="title.type != 3" class="title-options">
        <div class="option" v-for="(option, index) in title.options" :key="index">
          <div class="option-head">
            <span
              :class="[
                title.type === 1 ? 'radio' : title.type === 2 ? 'checkbox' : '',
                option.isCorrect === 1 ? 'correct' : ''
              ]"
              class="num"
              >{{ option.name }}</span
            >
            <div class="label">{{ option.content }}</div>
          </div>
          <div class="option-progress">
            <div class="progress">
              <div :style="{width: `${Number(option.accounted)}%`}" class="progress-content"></div>
            </div>
            <div class="percentage">{{ Number(option.accounted) }}%</div>
            <div @click="handle2DetailPerson(title.eventExamTitleId, option.eventExamOptionsId, 1)" class="answer-num">
              {{ option.answerCounts }}人
            </div>
          </div>
        </div>
      </div>
      <div class="title-ans" v-else>
        <span @click="handle2DetailPerson(title.eventExamTitleId, '', 2)"
          >共提交{{ title.answersCount ? title.answersCount : 0 }}份答案</span
        >
      </div>
    </div>
  </div>
</template>

<script>
import {getbasetotal} from '@/api'
export default {
  data() {
    return {
      typeLabel: ['', '单选', '多选', '问答'],
      id: this.$route.params.id,
      paperId: this.$route.query.paperId,
      titles: [],
      answerCount: 0
    }
  },
  created() {
    this.getStatus2Detail()
  },
  methods: {
    async getStatus2Detail() {
      const result = await getbasetotal({paperId: this.paperId, eventId: this.id})
      if (result.code === 0) {
        this.titles = result.data.titles || []
        this.answerCount = result.data.answerCounts || 0
      }
    },
    handle2DetailPerson(titleId, optionId, type) {
      this.$router.push(`/activeAnsDetailPerson/${this.id}?titleId=${titleId}&optionId=${optionId}&type=${type}`)
    }
  }
}
</script>

<style scoped lang="scss">
.answer-detail {
  padding: 10px;
  .ans-count {
    color: #909399;
    margin-bottom: 20px;
  }
}

.title-item {
  margin-bottom: 30px;
  .title-head {
    .index {
      color: rgba(48, 49, 51, 1);
      font-weight: 700;
    }
    .type {
      color: rgba(192, 196, 204, 1);
      margin: 0 4px;
    }
    .name {
      word-break: break-all;
      color: rgba(48, 49, 51, 1);
      font-weight: 700;
    }
  }
  .title-ans {
    margin-top: 20px;
    text-align: center;
    color: rgba(68, 101, 243, 1);
    background: #f1f3f6;
    line-height: 40px;
  }
  .title-options {
    .option {
      margin-top: 20px;
    }
    .option-head {
      position: relative;
      padding-left: 40px;
    }
    .option-progress {
      margin-top: 14px;
      display: flex;
      align-items: center;
      .progress {
        flex: 1;
        background: #f1f3f6;
        border-radius: 10px;
        position: relative;
        height: 10px;
        div {
          position: absolute;
          left: 0;
          top: 0;
          width: 0;
          height: 10px;
          border-radius: 10px;
          background: rgba(9, 165, 46, 1);
        }
      }
      .percentage {
        text-align: center;
        color: #909399;
        width: 60px;
      }
      .answer-num {
        text-align: center;
        color: #4465f3;
        width: 60px;
      }
    }
    .num {
      position: absolute;
      left: 0;
      top: 0;
      display: inline-block;
      width: 28px;
      height: 28px;
      text-align: center;
      line-height: 28px;
      background: #eef0f3;
      color: #333333;
      &.radio {
        border-radius: 50%;
      }
      &.checkbox {
        border-radius: 4px;
      }
      &.correct {
        color: #fff;
        background: rgba(9, 165, 46, 1);
      }
    }
    .label {
      text-align: justify;
      color: #606266;
      word-break: break-all;
    }
  }
}
</style>
